import { SxProps, Theme } from "@mui/material";

import { MAIN_CONTENT_PADDING_X } from "@/common/components/layout/Layout.constants";

const GROUND_PADDING = 1.5;
const SHEET_PADDING = 2;
const CONTENT_MIN_WIDTH = 1200;

/**
 * The page ground the client file sits on. Without a tint this is the plain scroll container it has
 * always been. With one, it cancels the layout's horizontal padding so the colour reaches the app
 * navigation on the left and the window edge on the right, and pads itself back to a frame around
 * the white sheet. That frame is deliberately slimmer than the layout padding it replaces: together
 * with the sheet's own padding it is what the content moves by when the tint is switched on.
 */
export function clientFileGroundSx(tint: string | undefined): SxProps<Theme> {
  return {
    overflowX: "auto",
    overflowY: "hidden",
    ...(tint && {
      bgcolor: tint,
      mx: -MAIN_CONTENT_PADDING_X,
      p: GROUND_PADDING,
    }),
  };
}

/**
 * The client file itself. On a tinted ground it becomes the white sheet everything is drawn on; the
 * minimum width grows by the sheet's own padding so the content keeps the width it has untinted.
 */
export function clientFileSheetSx(isTinted: boolean): SxProps<Theme> {
  return {
    minWidth: isTinted
      ? (theme: Theme) => `calc(${CONTENT_MIN_WIDTH}px + 2 * ${theme.spacing(SHEET_PADDING)})`
      : CONTENT_MIN_WIDTH,
    ...(isTinted && {
      bgcolor: "background.paper",
      borderRadius: 2,
      p: SHEET_PADDING,
    }),
  };
}
